import Container from '@components/ui/Container/Container'
import { CSSProperties, FC } from 'react'
import styles from './StoriesText.module.scss'

export type StoriesTextProps = {
  headline?: string
  maxWidth?: number
  fitContent?: 'Min-Content' | undefined
  position?: 'Left' | 'Center' | 'Right' | undefined
  backgroundColor?: string
  backgroundColor1?: string
  container?: boolean
  paddingTop?: number
  paddingBottom?: number
  paddingLeft?: number
  paddingRight?: number
  textDefaultColor?: string
}

const StoriesText: FC<StoriesTextProps> = ({
  headline,
  maxWidth,
  fitContent,
  position,
  backgroundColor,
  backgroundColor1,
  textDefaultColor,
  container,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
}) => {
  const bgHex = backgroundColor ?? backgroundColor1

  // screen reader for SEO optimization in the title

  const pageData = (
    <div
      style={
        {
          width:
            removeWhitespaces(fitContent) ??
            `${maxWidth == 0 ? 100 : maxWidth}vw`,
          paddingLeft: paddingLeft ? `${paddingLeft}vw` : undefined,
          paddingTop: paddingTop ? `${paddingTop}vw` : undefined,
          paddingRight: paddingRight ? `${paddingRight}vw` : undefined,
          paddingBottom: paddingBottom ? `${paddingBottom}vw` : undefined,
          color: textDefaultColor ? textDefaultColor : undefined,
          margin: position
            ? `${
                position == 'Center'
                  ? '0 auto'
                  : position == 'Right'
                  ? '0 0 0 auto'
                  : '0 auto 0 0'
              }`
            : `0 auto`,
          '--letter-count': headline.split('').length,
        } as CSSProperties
      }
      className={styles.headline}
    >
      <div className={styles.text}>
        {headline.split('').map((letter, index) => (
          <div key={index}>{letter}</div>
        ))}
      </div>
    </div>
  )

  return container ? (
    <Container backgroundColor={`#${bgHex}`}>{pageData}</Container>
  ) : (
    pageData
  )
}

const removeWhitespaces = (str?: string) => {
  if (str == undefined || str.trim() == '') return null
  return str
}

export default StoriesText
